import { DOCUMENT, effect, EffectRef, inject, Injectable, signal, Type, WritableSignal } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { DialogService } from '@libs/shared/common';
import { NO_PERMISSION_DIALOG_COMPONENT_TYPE, NO_PERMISSION_NOTIFICATION_STORAGE_KEY } from './no-permission-notification.model';

@Injectable({ providedIn: 'root' })
export class NoPermissionNotificationService {
  private readonly componentCtr: Type<unknown> = inject(NO_PERMISSION_DIALOG_COMPONENT_TYPE);
  private readonly document: Document = inject(DOCUMENT);
  private readonly dialog: DialogService = inject(DialogService);

  private readonly isPending: WritableSignal<boolean> = signal<boolean>(this.checkPendingStateAndClear());

  private readonly dialogTrigger: EffectRef = effect(() => {
    if (this.isPending()) {
      this.dialog.open(this.componentCtr, this.dialogSettings);
    }
  });

  private readonly dialogSettings: MatDialogConfig = {
    maxWidth: '40rem',
  };

  public markPending(): void {
    // Save the flag so it survives the logout and page reload
    this.getStorage()?.setItem(NO_PERMISSION_NOTIFICATION_STORAGE_KEY, '1');
  }

  private checkPendingStateAndClear(): boolean {
    const storage: Storage | undefined = this.getStorage();

    if (storage?.getItem(NO_PERMISSION_NOTIFICATION_STORAGE_KEY) === '1') {
      storage.removeItem(NO_PERMISSION_NOTIFICATION_STORAGE_KEY);

      return true;
    }

    return false;
  }

  private getStorage(): Storage | undefined {
    // The session storage may fail in SSR or private mode, so the error should be ignored
    try {
      return this.document.defaultView?.sessionStorage;
    } catch {
      return undefined;
    }
  }
}
